<div class="unauthorized-container">
  <div class="unauthorized-card">
    <h1>403</h1>
    <h2>Unauthorized Access</h2>
    <p>You don’t have permission to view this page.</p>
    <button mat-raised-button color="primary" (click)="onUnauthorized()">Go to Home</button>
  </div>
</div>
